<template>
  <img :src="src" alt="" @error="onError" :width="width" :height="height" />
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "",
    },
  },
  methods: {
    onError(e) {
      e.target.src = require("../assets/images/placeholder.svg");
    },
  },
};
</script>

<style scoped>
img {
  object-fit: contain;
}
</style>